import { Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CustomValidators, CuttingCadModel, CuttingSettings } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cutting-order-file-detail-dialog',
  templateUrl: './order-file-detail-dialog.component.html',
  styleUrls: ['./order-file-detail-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderFileDetailDialogComponent implements OnInit, OnDestroy {
  _cadModel: CuttingCadModel;
  fileForm: UntypedFormGroup;
  fileFormErrors: Record<string, ValidationErrors>;
  unsubscribe$: Subject<void> = new Subject();
  options: CuttingSettings;

  @Input() forbiddenSigns: string[] = [];

  @Input() set cadModel(val: CuttingCadModel) {
    this._cadModel = _.cloneDeep(val);
  }

  constructor(
    public dialogRef: MatDialogRef<OrderFileDetailDialogComponent>, //
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_LEGACY_DIALOG_DATA) data: { cuttingSettings: CuttingSettings }
  ) {
    this.fileFormErrors = {
      sign: {},
      count: {},
    };

    this.options = data.cuttingSettings;
  }

  ngOnInit(): void {
    this.fileForm = this.formBuilder.group({
      sign: [
        '',
        [
          Validators.required,
          Validators.maxLength(this.options.cudModelSettings.maxSignLength),
          this.signSameness(this.forbiddenSigns),
        ],
      ],
      count: ['', [Validators.required, CustomValidators.range([1, 100]), CustomValidators.number]],
    });

    this.fileForm.patchValue(this._cadModel);

    this.fileForm.valueChanges //
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.onFileFormValuesChanged();
      });
  }

  signSameness(forbiddenSigns: string[]): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (forbiddenSigns.includes(c.value.trim())) {
        return { signSameness: true };
      }
      return null;
    };
  }

  onFileFormValuesChanged(): void {
    for (const field in this.fileFormErrors) {
      // Clear previous errors
      this.fileFormErrors[field] = {};

      // Get the control
      const control = this.fileForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.fileFormErrors[field] = control.errors;
      }
    }
  }

  saveAndClose(): void {
    this._cadModel.sign = this.fileForm.controls.sign.value;
    this._cadModel.count = this.fileForm.controls.count.value;

    this.dialogRef.close(this._cadModel);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
